<template>
  <div class="tax-report-list">
    <TitleBar>
      <template v-slot:title>
        <translate>VAT reports (Beta)</translate>
      </template>
      <template v-slot:buttons>
        <GekkoButton
          :text="$gettext('New Report')"
          type="button"
          v-if="isAccountantUser"
          class="mr-2"
          @click="triggerNewReportModal"
        />
        <GekkoButton
          v-if="!$route.path.includes('control-panel')"
          :text="$gettext('All Reports')"
          icon="fa-solid fa-chart-column"
          type="button"
          variant="outline-primary"
          :to="{ name: 'Reports' }"
        />
      </template>
    </TitleBar>
    <ReportsVATNewModal
      v-if="showNewReportModal"
      @close="onNewReportClose"
      @submit="onNewReportSubmit"
      :financialYears="financialYears"
      :year="year"
      :quarter="quarter"
      :month="null"
      :consolidated="false"
      :onlyQuarter="true"
    />
    <div class="content">
      <div class="row">
        <div class="col-lg-11 col-md-11 col-xs-11">
          <ul class="list-unstyled reports-list" v-for="aYearOfReports in reportsByYear" :key="aYearOfReports.id">
            <template>
              <h2>{{ aYearOfReports.year }}</h2>
              <li v-for="report in _orderedReports(aYearOfReports.reports)" :key="report.id">
                <div v-if="!report.blank">
                  <GekkoButton
                    class="primary"
                    icon="fa fa-eye"
                    v-bind:text="
                      $gettext('report for ') +
                      report.quarter +
                      ' ' +
                      aYearOfReports.year +
                      ' (' +
                      $gettext('Calculated on: ') +
                      $options.filters.formatDate(report.modified) +
                      ')'
                    "
                    variant="link"
                    :to="{ name: 'VATReportBE', params: { id: report.id } }"
                  />
                </div>
                <div v-if="report.blank">
                  <GekkoButton
                    class="text-blue"
                    icon="fa fa-plus-circle"
                    :text="$gettext('new report for ') + report.quarter + ' ' + aYearOfReports.year"
                    variant="link"
                    @click="preselectedGenerateReportModal(report.year, report.quarter)"
                  />
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReportsVATNewModal from '@/components/ReportsVATNewModal'
import settingsPageSetup from '@/mixins/settingsPageSetup'
import VATBelgianReportService from '@/store/services/belgianvatreport.service'
import CompanyService from '@/store/services/company.service'
import GekkoButton from '@/components/GekkoButton'
import TitleBar from '@/components/TitleBar'
import { mapGetters } from 'vuex'
import VATReportBE from '@/views/gekko/VATReportBE'

export default {
  name: 'VATReportBEList',
  components: { TitleBar, ReportsVATNewModal, GekkoButton, VATReportBE },
  mixins: [settingsPageSetup],
  computed: {
    ...mapGetters({
      getCompanyId: 'main/getCompanyId'
    }),
  },
  data() {
    return {
      pageSettings: {
        title: this.$gettext('Reports'),
        showCompanyPicker: true,
      },
      isAccountantUser: true,
      reportsByYear: [],
      reports: [],
      financialYears: [],
      showNewReportModal: false,
      year: null,
      quarter: null,
    }
  },
  filters: {
    formatDate: function (value) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(value).toLocaleDateString('en-US', options)
    },
  },
  created() {
    Promise.all([
      VATBelgianReportService.list({ company: this.getCompanyId }),
      CompanyService.financiallyActiveYears(this.getCompanyId),
    ]).then((responses) => {
      this.reports = responses[0].data
      this.financialYears = responses[1].data
      this.reportsByYear = this._reorganizeReports(this.financialYears, this.reports)
    })
  },
  methods: {
    triggerNewReportModal() {
      this.year = null
      this.quarter = null
      this.showNewReportModal = true
    },
    preselectedGenerateReportModal(year, quarter) {
      let vm = this
      vm.year = year
      vm.quarter = quarter

      this.showNewReportModal = true
    },
    _reorganizeReports(years, reports) {
      var outputReports = []
      for (var i = 0; i < years.length; i++) {
        var thisYear = years[i]
        var thisYearReports = {
          year: thisYear,
          reports: {
            Q1: { quarter: 'Q1', year: thisYear, blank: true },
            Q2: { quarter: 'Q2', year: thisYear, blank: true },
            Q3: { quarter: 'Q3', year: thisYear, blank: true },
            Q4: { quarter: 'Q4', year: thisYear, blank: true },
          },
        }
        for (var j = reports.length - 1; j > -1; j--) {
          if (reports[j].year === parseInt(thisYear)) {
            thisYearReports.reports[reports[j].quarter] = reports[j]
          }
        }
        outputReports.push(thisYearReports)
      }
      return outputReports
    },
    _orderedReports(reports) {
      //Ordered by quarter, in descending order
      var reportsArray = Object.entries(reports)
      reportsArray.sort(function compareQuarters([, a], [, b]) {
        if (a.quarter > b.quarter) {
          return -1
        }
        if (a.quarter < b.quarter) {
          return 1
        }
        return 0
      })
      var reportsArrayResult = []
      reportsArray.forEach((element) => {
        reportsArrayResult.push(element[1])
      })
      return reportsArrayResult
    },
    onNewReportSubmit(report_initial_values) {
      this.showNewReportModal = false
      this.$store.commit('taxreports/setBelgianReportInitialValues', report_initial_values)
      this.$router.push({ name: 'VATReportBECreate' })
    },
    onNewReportClose() {
      this.showNewReportModal = false
    },
  },
}
</script>
<style lang="scss">
.tax-report-list {
  .content {
    padding: 0 0.5rem;
    @media (min-width: '576px') {
      padding: 0 1rem;
    }
  }
}
</style>